import React from 'react';
import { BsThreeDots } from 'react-icons/bs';
import { Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import './MoreButton.scss';
import { useRouter } from '../../../../helpers/customHooks';
import { PerformanceRoutes } from '../types';

const CustomToggle = React.forwardRef((
  { children, onClick } : { children: React.ReactNode, onClick: React.MouseEventHandler<HTMLDivElement>}
  , ref: React.Ref<HTMLDivElement>) => (
  <div
    ref={ref}
    onClick={e => {
      e.stopPropagation();
      e.preventDefault();
      onClick(e);
    }}
    className="performance-more-button"
  >
    {children}
  </div>
));

const CustomMenu = React.forwardRef((
  { children, style, className, 'aria-labelledby': labeledBy } : { children: React.ReactNode, style: React.CSSProperties, className: string, 'aria-labelledby'?: string }
  , ref: React.Ref<HTMLDivElement>) => {

    return (
      <div
        ref={ref}
        style={{ ...style, top: '-43px', paddingLeft: '3px' }}
        className={className}
        aria-labelledby={labeledBy}
      >
        {children}
      </div>
    );
  }
);

const MoreButton = ({ metric } : { metric: string}) => {

  const { history, params, pathname, search } = useRouter<PerformanceRoutes>();
  const view = params.subTab;

  const changePage = (metric: string) => {
    const params = history.location.pathname.split('/').slice(0, 4);
    params.push('performance');
    params.push('metrics');
    params.push('byPeriod');
    params.push(view);
    params.push(metric);
    return params.join('/');
  };
  // const popover = (
  //   <Popover id="popover-basic" onClick={e => {
  //                                         e.stopPropagation();
  //                                         e.preventDefault();
  //                                       }}>
  //     <Popover.Content>
  //        <Link to={{pathname: changePage(metric)}}>
  //          Open Player Totals by Period
  //       </Link>
  //     </Popover.Content>
  //   </Popover>
  // );

  return (
    // <OverlayTrigger trigger="click" placement="left" overlay={popover} rootClose onClick={e => {
    //   e.nativeEvent.stopPropagation();
    //   e.preventDefault();
    // }}>
    //   <BsThreeDots size={16}/>
    // </OverlayTrigger>
    <Dropdown className="more-periods">
      <Dropdown.Toggle as={CustomToggle} id="more-button-headers">
        <BsThreeDots size={16} />
      </Dropdown.Toggle>

      <Dropdown.Menu as={CustomMenu} style={{}}>
        <Link
          to={{
            pathname: changePage(metric),
            state: {
              toReturn: pathname,
              oReturnSearch: search,
            }
          }}
          className="more-dropdown"
        >
          Open Player Totals by Period
        </Link>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default MoreButton;
